import { combineReducers } from 'redux';

import { State, Type } from '../actions/utils';

import initialState from './initial';
import { clearedDefaults, failedDefaults, requestedDefaults, succeededDefaults } from './utils';

const list = (state: any = initialState.quotes.list, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.GET_QUOTE_LIST):
      return clearedDefaults(state);
    case State.actionRequested(Type.GET_QUOTE_LIST):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.GET_QUOTE_LIST):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_QUOTE_LIST):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.quotes.list;
    default:
      return state;
  }
};

const details = (state: any = initialState.quotes.details, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.GET_QUOTE):
      return clearedDefaults(state);
    case State.actionRequested(Type.GET_QUOTE):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.GET_QUOTE):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_QUOTE):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.quotes.details;
    default:
      return state;
  }
};

const chart = (state: any = initialState.quotes.chart, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.GET_QUOTE_CHART):
      return clearedDefaults(state);
    case State.actionRequested(Type.GET_QUOTE_CHART):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.GET_QUOTE_CHART):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_QUOTE_CHART):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.quotes.chart;
    default:
      return state;
  }
};

export const quoteReducers = combineReducers({
  list,
  details,
  chart,
});
